import { render, staticRenderFns } from "./LegacyProductStatementDeclaration.vue?vue&type=template&id=09f4572f&"
import script from "./LegacyProductStatementDeclaration.vue?vue&type=script&lang=js&"
export * from "./LegacyProductStatementDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports